import { eventTypeStandard } from './internal/core';
import { pushWithGlobalSale } from './internal/pushWithGlobal';

export type UseTrackingOfferReturn = {
    trackOfferCancel: VoidFunction;
    trackOfferPlaceBid: (isAutoBid: boolean, amount: number) => void;
    trackOfferDecrement: (amount: number) => void;
    trackOfferIncrement: (amount: number) => void;
    trackOfferChip: (amount: number) => void;
    trackOfferReset: (amount: number) => void;
};

export const useTrackingOffer = (): UseTrackingOfferReturn => ({
    trackOfferCancel(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'cancel',
            page_type: 'offer',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackOfferPlaceBid(isAutoBid, amount): void {
        pushWithGlobalSale(
            sales => ({
                event: 'click',
                click_element: 'button',
                click_text: 'place_bid',
                page_type: 'offer',
                auto_bid_option: String(isAutoBid),
                sales,
                ...eventTypeStandard,
            }),
            { value: amount }
        );
    },

    trackOfferDecrement(amount): void {
        pushWithGlobalSale(
            sales => ({
                event: 'click',
                click_element: 'button',
                click_text: 'minus',
                page_type: 'offer',
                sales,
                ...eventTypeStandard,
            }),
            { value: amount }
        );
    },

    trackOfferIncrement(amount): void {
        pushWithGlobalSale(
            sales => ({
                event: 'click',
                click_element: 'button',
                click_text: 'plus',
                page_type: 'offer',
                sales,
                ...eventTypeStandard,
            }),
            { value: amount }
        );
    },

    trackOfferChip(amount): void {
        pushWithGlobalSale(
            sales => ({
                event: 'click',
                click_element: 'button',
                click_text: 'chip',
                page_type: 'offer',
                sales,
                ...eventTypeStandard,
            }),
            { value: amount }
        );
    },

    trackOfferReset(amount): void {
        pushWithGlobalSale(
            sales => ({
                event: 'click',
                click_element: 'button',
                click_text: 'reset',
                page_type: 'offer',
                sales,
                ...eventTypeStandard,
            }),
            { value: amount }
        );
    },
});
